import { Modal, ModalSize, ModalType } from '@ukpostbox/frontend-framework';
import React from 'react';
import { HarmonySearchResults } from '../Controls/HarmonySearchResults';
import { HarmonySearchDetailed } from '../Controls/HarmonySearchDetailed';

interface CommoditySearchModalType extends ModalType {
	harmonyCodes?: any;
	commodityHeading?: any;
	getCommodityCodes: (searchTerm?: string) => void;
	getCommodityCodeHeading: (headingId: string) => void;
}

function HarmonySearchModal(props: CommoditySearchModalType) {
	const HandleCodeSelection = (id: string, type?: string) => {
		if (type === 'Commodity') {
			console.log('HandleCodeSelection');
			props.actionedCallback(id);
		} else {
			props.getCommodityCodeHeading(id);
		}

		/*        switch(type) {
            case 'Heading':
                GetCommodityCodeHeading(id);
                break;
            case 'Subheading':
                GetCommodityCodeHeading(id);
                break;
            case 'Commodity':
                GetCommodityCodeHeading(id);
                break;
            default:
        } */
	};

	const HandleNestedSelection = (id: string, type?: string) => {
		if (type === 'selected' && props.actionedCallback) {
			props.actionedCallback(id);
		} else {
			HandleCodeSelection(id);
		}
	};

	return (
		<Modal
			title='Harmony Lookup'
			isOpen={props.isOpen}
			closeCallback={props.closeCallback}
			modalSize={ModalSize.Large}
		>
			<div>
				<input type='text' onBlur={(e) => props.getCommodityCodes(e.currentTarget.value)} />
			</div>

			<div className='row'>
				<div className={props.commodityHeading.commodities ? 'col-md-6' : 'col-md-12'}>
					<HarmonySearchResults
						harmonyCodes={props.harmonyCodes}
						selectedCallback={(id: string, type: string) => HandleCodeSelection(id, type)}
					/>
				</div>
				{props.commodityHeading.commodities && (
					<div className='col-md-6'>
						<HarmonySearchDetailed
							commodityHeading={props.commodityHeading}
							lookupCallback={(id: string) => HandleNestedSelection(id)}
							selectedCallback={(id: string) => HandleNestedSelection(id, 'selected')}
						/>
					</div>
				)}
			</div>
		</Modal>
	);
}

export { HarmonySearchModal };
